/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import { useTheme } from "@mui/material/styles";
import useStyles from "cms/fields/_styles";
import { ComponentIcon } from "cms/components/components/component-icon";
import { useComponentConfig } from "cms/models/hooks/use-components-config";

const EmptyContentMessage = (props) => {
    
    const {
        hasContent = false,
        message = "",
        component
    } = props || {};
    const classes = useStyles();
    const theme = useTheme();
    const { type = "" } = component || {};
    // const Icon = getIcon(type)
    let msg = message;
    const componentConfig = useComponentConfig(type);
    const title = componentConfig?.title;
    if (!message) {
        msg = `No ${title} content to display. Click "Edit Content" to configure.`;
    }
    
    return (
        <Fragment>
            {!hasContent && (
                <div className={classes.embedPlaceholder}>
                    <div>
                        <ComponentIcon 
                            component={type} 
                            style={{ marginTop: "6px", fill: theme.palette.grey[400] }}
                        />
                    </div>
                    <div><div style={{ fontSize: "1em" }}>{msg}</div></div>
                </div>
            )}
        </Fragment>
    );
};

EmptyContentMessage.displayName = "EmptyContentMessage";
export { EmptyContentMessage };
